import { Pagination } from '@frontend/components';

import { useTableContext } from '../utils/TableContext';
import { useSelectionContext } from '../utils/selectHelpers';

/**
 * @deprecated use TableV2 and its subcomponents from '@frontend/components' instead.
 */
const TablePagination = ({
  paginationOptions,
  currentPage,
  setCurrentPage,
  onChange,
}) => {
  const selectionContext = useSelectionContext();
  const { filterConfigs } = useTableContext();
  return (
    <Pagination
      className="pagination"
      totalItems={paginationOptions.totalItems}
      itemsPerPage={paginationOptions.itemsPerPage}
      currentPage={currentPage}
      onChangePage={(current) => {
        onChange?.({
          filters: filterConfigs,
          page: current,
        });
        setCurrentPage(current);
        selectionContext?.setLastSelected(null);
      }}
    />
  );
};

export default TablePagination;
